module.exports = __webpack_public_path__ + "img/banner_32.58c35c81.jpg";